import { AgAreaSeriesOptions, AgChartOptions } from 'ag-charts-enterprise';
import { formatDate } from 'date-fns';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { useMonthlyExpensesQuery } from '../../hooks/queries/useDashboardQuery';
import { capitalizeFirstLetter } from '../../utils/capitalize';
import GenericAgChart from './GenericAgChart';

interface ExpensesAreaChartProps {
    today: string;
}

const ExpensesAreaChart: React.FC<ExpensesAreaChartProps> = ({ today }) => {
    const { t } = useTranslation();

    const { data: dataDailyExpenses } = useMonthlyExpensesQuery({ date: today });

    const options: AgChartOptions = {
        data: dataDailyExpenses || [],
        series: [
            {
                type: 'area',
                xKey: 'day',
                xName: capitalizeFirstLetter(t('date')),
                yKey: 'total',
                yName: capitalizeFirstLetter(t('expenses')),
                stacked: false,
                interpolation: {
                    type: 'smooth',
                },
                fill: '#8ebda2',
                stroke: '#8ebda2',
                strokeWidth: 2,
            } as AgAreaSeriesOptions,
        ],
        axes: [
            {
                type: 'category',
                position: 'bottom',
                label: {
                    formatter: (params: { value: string }) => {
                        return formatDate(new Date(params.value), 'dd/MM');
                    },
                },
            },
            {
                type: 'number',
                position: 'left',
            },
        ],
    };

    return <GenericAgChart options={options} />;
};

export default ExpensesAreaChart;
